<template>
    <page>
        <module>
            <view-list ref="view"  :work-type="workType" selector :view-config="saasInfo.viewmanage">
                <template #search>
                    <m-search ref="search">
                        <m-search-item label="采购单号">
                            <c-input name="purchase_code"></c-input>
                        </m-search-item>
                        <m-search-item label="商品信息">
                            <c-input name="product_info"></c-input>
                        </m-search-item>
                        <m-search-item label="售卖人信息">
                            <c-input name="seller_info"></c-input>
                        </m-search-item>
                        <m-search-item label="背贴码">
							<c-input name="product_code"></c-input>
                        </m-search-item>
                        <m-search-item label="第三方订单号">
							<c-input name="third_order_number"></c-input>
                        </m-search-item>
                        <m-search-item label="创建时间">
                            <c-datetime range start-name="start_date" end-name="end_date"></c-datetime>
                        </m-search-item>
                    </m-search>
                </template>

                <template #operate>
                    <c-button v-if="auth('b_purchase_bidding_order_export')" prepend-icon="tf-export" @click="$refs.view.exportListByViewId()">导出</c-button>
                </template>

                <!--多选后操作栏切换为批量模式：显示已选条数并可取消勾选，按钮与常态操作栏保持一致-->
                <template #batchOperate>
                    <c-button v-if="auth('b_purchase_bidding_order_export')" prepend-icon="tf-export" @click="$refs.view.exportListByViewId()">导出</c-button>
                </template>

                <!--采购单状态-->
                <template #purchase_state="{data}">
                    <c-state tag async dict="PURCHASE_ORDER_STATE" :value="data.purchase_state"></c-state>
                </template>
                <!--采购单类型-->
                <template #purchase_type="{data}">
                    <c-state tag async dict="PURCHASE_ORDER_TYPE" :value="data.purchase_type"></c-state>
                </template>
                <!--采购渠道-->
                <template #purchase_channel="{data}">
                    <c-state tag async dict="PURCHASE_CHANNEL" :value="data.purchase_channel"></c-state>
                </template>
                <!--采购总价-->
                <template #purchase_money="{data}">
                    ￥{{data.purchase_money}}
                </template>
                <!--统计数据-->
                <template #statistic_data="{data}">
                    收 {{data.purchase_count}}
                    验 {{data.checked_count}}
                    退 {{data.return_count}}
                </template>
                <!--售卖人信息-->
                <template #seller_info="{data}">
                     {{data.seller_name}}
                     {{data.seller_phone}}
                     {{data.seller_address}}
                </template>

                <c-table-column
                        type="button"
                        label="操作"
                        width="180"
                        button-limit="6"
                >
                    <template #default="{data}">
                        <c-table-button @click="globalDialog('purchaseDetail', {props: {id: data.id}})">查看</c-table-button>
                        <c-table-button v-if="auth('b_purchase_bidding_order_receive') && data.purchase_state == 1"
                                        @click="$refs.productUniqueCodeReceiveCheck.open(false, data)">确认收货并初检</c-table-button>
                        <c-table-button v-if="auth('b_purchase_bidding_order_edit')" @click="editPurchaseOrder(2,data)"
                                        :disabled="data.purchase_state == 1 || data.purchase_state == 4 || data.purchase_state == 6 || data.purchase_state == 7">编辑</c-table-button>
                    </template>
                </c-table-column>
            </view-list>

			<!--唯一码初检弹窗-->
			<product-unique-code-receive-check ref="productUniqueCodeReceiveCheck" @resolve="$refs.view.update();"></product-unique-code-receive-check>
        </module>
    </page>
</template>

<script>
import {mapState} from 'vuex'
import productUniqueCodeReceiveCheck from "@/pages/product/product_unique_code_receive_check.vue";

export default {
    components: {
		productUniqueCodeReceiveCheck
	},

    computed: {
        ...mapState(['saasInfo','userInfo'])
    },

    data() {
        return {
            workType: 43,
            supplierId:0
        }
    },

    methods: {
        /**
         * 编辑线购单
         * @param operation_type    操作类型 1=确认收货 2=编辑
         * @param data              采购单数据
         */
        editPurchaseOrder(operation_type,data) {
            this.globalDialog('onlinePurchaseEdit', {
                props: {
                    operation_type: operation_type
                },
                data:data
            }, () => {
                //刷新页面
                this.$refs.view.update();
            });
        },
        /**
         * 确认收货
         */
        receipt(data) {
            this.$confirm({
                message:'是否确认采购单【' + data.purchase_code + '】已收到货品？确认后，采购单状态将变更为“待质检”，允许编辑采购单并录入商品信息',  // 提示内容,
                buttonName: '确定',  // 确定按钮文字
                cancelButton: true,  // 是否显示取消按钮
                resolve: () => {
                    this.request({
                        url: '/online/purchase/order/receipt',
                        data: {
                            purchase_order_id: data.id,
                        },
                        loading: true,
                        success: data => {
                            //刷新列表
                            this.$refs.view.update();
                            this.$message({
                                message: '确认收货成功',  // 提示内容,
                                type: 'success'
                            });
                        }
                    });
                },  // 确定按钮回调
                cancel: () => {},  // 取消按钮回调
            });
        }
    }
}
</script>

<style lang="stylus" scoped>
</style>